import { useTranslation } from "react-i18next";
import "./index.scss";

export const CarrouselScreen = () => {
  const { t } = useTranslation();

  const sections = [
    {
      title: t("presentationPage.strong-community-title"),
      description:  t("presentationPage.strong-community-desc"),
    },
    {
      title:  t("presentationPage.community-tailored-title"),
      description: t("presentationPage.community-tailored-desc"),
    },
    {
      title: t("presentationPage.chat-title"),
      description: t("presentationPage.trusted-desc")},
    {
      title: t("presentationPage.trusted-title"),
      description: t("presentationPage.trusted-title"),
    },
  ];

  return (
    <div className="c-carrousel-screen">
      {sections.map((section, index) => {
        return (
          <div key={section.title} className="c-carrousel-screen__section">
            <div className="c-carrousel-screen__section-number">
              {index + 1 < 10 && "0"}
              {index + 1}
            </div>
            <div className="c-carrousel-screen__section-info">
              <div className="c-carrousel-screen__section-title">
                {section.title}
              </div>
              <div className="c-carrousel-screen__section-description">
                {section.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
